import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";

export function EventDialog({ event, onClose, onSaved }) {
  const isEdit = !!event?.id;
  const [f, setF] = useState({ title: "", date: "", time: "", description: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (event) {
      setF({ title: event.title || "", date: event.date, time: event.time || "", description: event.description || "" });
    }
  }, [event]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (isEdit) {
        await api.put(`/events/${event.id}`, f);
        toast.success("Impegno aggiornato");
      } else {
        await api.post("/events", f);
        toast.success("Impegno aggiunto");
      }
      onSaved();
      onClose();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!event} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-white" data-testid="event-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">{isEdit ? "Modifica impegno" : "Nuovo impegno"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Titolo *</Label><Input required value={f.title} onChange={set("title")} placeholder="es. Ritiro mobili via Roma" data-testid="event-title-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Giorno *</Label><Input type="date" required value={f.date} onChange={set("date")} data-testid="event-date-input" /></div>
            <div className="space-y-1.5"><Label>Ora</Label><Input type="time" value={f.time} onChange={set("time")} data-testid="event-time-input" /></div>
          </div>
          <div className="space-y-1.5"><Label>Appunti</Label><Textarea rows={3} value={f.description} onChange={set("description")} data-testid="event-description-input" /></div>
          <button className="btn-primary w-full h-11" disabled={saving} data-testid="event-submit-button">{saving ? "Salvataggio..." : isEdit ? "Salva modifiche" : "Aggiungi all'agenda"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
